// extracted by mini-css-extract-plugin
export default {"root":"header-menu_root__YwZFn"};